<!-- src/layouts/GameLayout.vue -->
<template>
    <!-- Header -->
    <AppHeader />

    <!-- Mobile header nav -->
    <MobileHeaderNav />

    <!-- Page renders here (the page provides page-heading + #app-container etc.) -->
    <RouterView />

    <!-- Overlay (outside #app-container as per design) -->
    <div class="overlay" id="overlay" @click="closeSideMenu"></div>

    <!-- Sticky footer nav (betslip summary + nav) -->
    <FooterNav />

    <!-- Footer -->
    <Footer />
</template>

<script setup>
import { RouterLink, RouterView } from 'vue-router'
import AppHeader from '@/components/AppHeader.vue'
import MobileHeaderNav from '@/components/MobileHeaderNav.vue'
import FooterNav from '@/components/FooterNav.vue'
import Footer from '@/components/Footer.vue'

function closeSideMenu() {
  const el = document.getElementById('sideMenuBar')
  if (el) el.classList.remove('show', 'open')
  const overlay = document.getElementById('overlay')
  if (overlay) overlay.classList.remove('show', 'open')
}
</script>
